import React from 'react';
import PropTypes from 'prop-types';
import Input from './Input';
import theme from '../../../theme';

function NumberInput({
  width,
  id,
  value,
  onChange,
  min,
  step,
  disabled,
  placeholder,
  'aria-label': ariaLabel,
}) {
  return (
    <Input
      type="number"
      id={id}
      value={value}
      onChange={onChange}
      min={min}
      step={step}
      disabled={disabled}
      placeholder={placeholder}
      aria-label={ariaLabel}
      style={{
        width: width || '70px',
        textAlign: 'center',
        padding: theme.spacing.countInputPadding,
      }}
    />
  );
}

NumberInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  min: PropTypes.string,
  step: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  width: PropTypes.string,
  'aria-label': PropTypes.string,
};

NumberInput.defaultProps = {
  id: undefined,
  value: undefined,
  onChange: undefined,
  min: undefined,
  step: undefined,
  disabled: false,
  placeholder: undefined,
  width: undefined,
  'aria-label': undefined,
};

export default NumberInput;
